import { render, staticRenderFns } from "./ArticlesReorder.vue?vue&type=template&id=21e5529a&"
import script from "./ArticlesReorder.vue?vue&type=script&lang=js&"
export * from "./ArticlesReorder.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesReorder.vue?vue&type=style&index=0&id=21e5529a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports